export default from './Checkbox'


// WEBPACK FOOTER //
// ./src/components/Checkbox/index.js